import { createAction } from 'redux-actions';

import { listPublic as listChannelVideos } from 'widget/redux/server/actions/channel/videos/list-public';

export const NAMES = {
  UPDATE: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.UPDATE',
  VIDEOS_RESET: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.VIDEOS_RESET',
  CATEGORY_RESET: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.CATEGORY.RESET',
  CATEGORY_UPDATE: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.CATEGORY.UPDATE',
};

const resetVideos = createAction(NAMES.VIDEOS_RESET);
export const resetCategory = createAction(NAMES.CATEGORY_RESET);
export const updateCategory = createAction(NAMES.CATEGORY_UPDATE);

export const loadFirstPage = (numberToLoadFirst, { category, tag, query }) => (dispatch, getState) => {
  dispatch(resetVideos({}));

  const state = getState();

  const nextPageOptions = {
    paging: {
      size: numberToLoadFirst,
      cursor: null,
    },
    query,
    tag,
    category,
  };

  return dispatch(listChannelVideos(state.currentChannelId, nextPageOptions));
};

// FIXME: pass category to loadMore
export const loadMore = (loadMoreNumber, nextVideosCursor) => (dispatch, getState) => {
  const state = getState();
  return dispatch(listChannelVideos(state.currentChannelId, {
    paging: {
      size: loadMoreNumber,
      cursor: nextVideosCursor,
    },
  }));
};



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/channel-videos-lazy-load.js